import React from "react";
import { getStatusColors } from "../../utils/assessmentCalendarRules";

const CalendarStatusBadge = ({ status, secondary }) => {
  if (!status) return null;
  const colors = getStatusColors(status);
  return (
    <span className="inline-flex flex-wrap items-center justify-end gap-1.5">
      <StatusPill status={status} colors={colors} />
      {secondary ? <StatusPill status={secondary} colors={getStatusColors(secondary)} /> : null}
    </span>
  );
};

function StatusPill({ status, colors }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium text-gray-700 whitespace-nowrap ${colors.bg}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full flex-shrink-0 ${colors.dot}`} aria-hidden="true" />
      {status}
    </span>
  );
};

export default CalendarStatusBadge;
